export const SCAN_MODES = [
  { id: "qr",           label: "QR Code",       kind: "local", hint: "Point at any QR code" },
  { id: "barcode",      label: "Barcode",        kind: "local", hint: "Point at any product barcode" },
  { id: "receipt",      label: "Receipt",        kind: "ai",    hint: "Capture receipt for smart extraction" },
  { id: "document",     label: "Document",       kind: "ai",    hint: "Summarize documents and forms" },
  { id: "business-card", label: "Business Card", kind: "ai",    hint: "Extract contact information" },
  { id: "product",      label: "Product",        kind: "ai",    hint: "Identify product details" },
  { id: "label",        label: "Label",          kind: "ai",    hint: "Explain label or packaging" },
  { id: "text",         label: "OCR / Text",     kind: "ai",    hint: "Extract all visible text" },
  { id: "object",       label: "Object ID",      kind: "ai",    hint: "Identify anything in view" },
];

export async function decodeCodeFromBlob(blob) {
  if (!("BarcodeDetector" in window)) return "";
  try {
    const detector = new BarcodeDetector({
      formats: [
        "qr_code", "code_128", "code_39", "code_93",
        "ean_13", "ean_8", "upc_a", "upc_e",
        "itf", "data_matrix", "pdf417", "aztec",
      ],
    });
    const bitmap = await createImageBitmap(blob);
    const results = await detector.detect(bitmap);
    bitmap.close?.();
    return results.map((r) => r.rawValue).join("\n");
  } catch {
    return "";
  }
}

export function scannerPromptForMode(id) {
  switch (id) {
    case "receipt":
      return `Extract data from this receipt image and return ONLY a valid JSON object — no markdown, no extra text:
{"merchant":"store name","date":"date string or null","total":"total with currency symbol","tax":"tax or null","category":"expense category like Food/Transport/Shopping","items":[{"name":"item","price":"price"}],"summary":"one-sentence human summary"}
If a field is not visible, use null. Return ONLY the JSON.`;

    case "business-card":
      return `Extract contact info from this business card and return ONLY valid JSON — no markdown, no extra text:
{"name":"full name","title":"job title or null","company":"company name or null","phone":"phone number or null","email":"email address or null","website":"website URL or null","address":"address or null","notes":"any other info or null"}
Return ONLY the JSON.`;

    case "document":
      return `Analyze this document image and return ONLY valid JSON — no markdown, no extra text:
{"title":"document type or title","summary":"2–3 sentence summary","keyPoints":["key point 1","key point 2"],"actionItems":["action 1"],"warnings":["warning or flag or null"]}
Return ONLY the JSON.`;

    case "product":
    case "label":
      return `Analyze this product or label image and return ONLY valid JSON — no markdown, no extra text:
{"productName":"product name","brand":"brand name or null","description":"what it is and what it does","category":"product category","keyInfo":["info 1","info 2"],"warnings":["warning or null"],"notes":"useful shopping or usage notes"}
Return ONLY the JSON.`;

    case "text":
      return "Extract ALL visible text from this image exactly as it appears. Preserve line breaks and structure. Return only the extracted text, no commentary.";

    case "object":
      return "Identify the main subject(s) in this image. Describe what it is, what it is used for, its approximate condition or quality, and any useful practical notes. Be concise and direct.";

    default:
      return "Analyze this image and describe what you see in useful, practical detail. Identify the main subject, context, and any relevant information the viewer should know.";
  }
}
